import { jsx as e, jsxs as d } from "react/jsx-runtime";
import { Badge as m, Box as f } from "@chakra-ui/react";
import { Children as S } from "react";
import { checkChildRendersToString as g, IconSizeConstants as p } from "./helper.js";
import { Icon as u } from "../icon/icon.js";
import { ThemeSpaceVariable as h } from "../../theme/theme-types.js";
function i({ icon: r, ...n }) {
  const { size: t, children: a } = n, c = p[t ?? "md"], l = r ? /* @__PURE__ */ e(u, { size: c, icon: r }) : null;
  return S.forEach(a, (s) => {
    if (!g(s)) throw new Error("Badge component: Invalid return type of children, must return string");
  }), /* @__PURE__ */ e(m, { ...n, children: /* @__PURE__ */ d(
    f,
    {
      display: "flex",
      flexDirection: "row",
      gap: h.XSmall,
      justifyContent: "center",
      alignItems: "center",
      children: [
        l,
        a
      ]
    }
  ) });
}
const o = ({ solid: r, ...n }) => /* @__PURE__ */ e(i, { variant: r ? "neutralSolid" : "neutral", ...n });
o.Primary = ({ solid: r, ...n }) => /* @__PURE__ */ e(i, { variant: r ? "primarySolid" : "primary", ...n });
o.Secondary = ({ solid: r, ...n }) => /* @__PURE__ */ e(i, { variant: r ? "secondarySolid" : "secondary", ...n });
o.Success = ({ solid: r, ...n }) => /* @__PURE__ */ e(i, { variant: r ? "successSolid" : "success", ...n });
o.Error = ({ solid: r, ...n }) => /* @__PURE__ */ e(i, { variant: r ? "errorSolid" : "error", ...n });
o.Warning = ({ solid: r, ...n }) => /* @__PURE__ */ e(i, { variant: r ? "warningSolid" : "warning", ...n });
o.Info = ({ solid: r, ...n }) => /* @__PURE__ */ e(i, { variant: r ? "infoSolid" : "info", ...n });
export {
  o as Badge
};
